import * as R from 'rambdax'
import {ensureArray} from 'tizra'
import {useHydrating} from './useHydration'

/**
 * Get a window property, with fallback to defaultValue, and consistency for
 * hydration.
 */
export function useWindow<P extends keyof Window>(p: P): Window[P] | undefined
export function useWindow<P extends keyof Window, D>(p: P, d: D): Window[P] | D
export function useWindow<P extends keyof Window>(path: P, defaultValue?: any) {
  return useHydrating() ? defaultValue : (
      R.pathOr(
        defaultValue,
        ensureArray(path),
        typeof window === 'undefined' ? undefined : window,
      )
    )
}
